"use strict";

import React from "react";
import _ from "lodash";
import AppConstants from "../../constants/AppConstants";
import DesignItemList from "./DesignItemList.jsx";
import DesignItem from "./DesignItem.jsx";

class DesignBlockList extends React.Component {
  _onItemClick = (page) => {
    this.props.onItemClick(page);
  };

  _isSiteCanvas = (block) => {
    return (
      _.get(block, "type") == AppConstants.DESIGN_TYPE_SITE_BLOCK ||
      _.get(block, "uses_site_block", false)
    );
  };

  render() {
    const { blocks, selected, label, loading, level, onItemClick } = this.props;

    const selectedId = this._getId(selected);
    const items = [];

    blocks.forEach(function (block, idx) {
      const icons = "icon " + (this._isSiteCanvas(block) ? "icon-site-canvas" : "icon-block-2");

      items.push(
        <DesignItem
          key={block.id + "-" + idx}
          label={block.name}
          active={block.id == selectedId}
          iconClasses={icons}
          onClick={this._onItemClick.bind(this, block)}
        />
      );
    }, this);

    return (
      <DesignItemList level={level} label={label} loading={loading}>
        {items}
      </DesignItemList>
    );
  }

  _getId(block) {
    let id = _.get(block, "block_id", false);
    if (!id) id = _.get(block, "site_block_id", false);
    return id;
  }
}

export default DesignBlockList;
